<template>
<nav class="list-nav">
  <div class="tabs" v-if="getWidth !== 'xs'">
    <ul v-if="tabItems && tabItems.length > 0">
      <li v-for="(item, index) in tabItems"
          :key="item"
          :class="{ 'is-active': activeItem === item }"
          :style="activeItem === item ? isActive : {}"
      >
        <a href="#" @click.prevent="onNavItemClick(item)">
          {{ getCategory(item) }}{{ suffix(index) }}
        </a>
      </li>
    </ul>
  </div>
  <div class="width-100 mb-8" v-else>
    <div   class="column is-12-mobile is-6-tablet is-4-desktop is-one-fifth-widescreen is-one-fifth-fullhd p-0">
      <div class=" is-grouped">
        <div class="width-100 select ">
          <select class="width-100 bold" v-model="navBar" >
            <option  v-for="(nav, index) in tabItems" :value="nav" :key="nav"><div>
              {{getCategory(nav)}}  {{suffix(index)}}
            </div></option>
          </select>
        </div>

      </div>
    </div>
  </div>
  <div v-if="activeItem === 'search_jobs'">
    <button @click="redirectHandler"
            class="button is-primary is-fullwidth no-text-transform">{{this.$t('widget.postAJob')}}
      <img src="@/assets/tool-tip.png" class="ml-2" v-tooltip="{content: this.$t('widget.thisJobsJob'), placement:'bottom', offset: '10px'}"/>
    </button>
  </div>
  <div v-if="activeItem === 'Browse Talent'">
    <button @click="redirectHandler"
            class="button is-primary is-fullwidth no-text-transform">{{this.$t('widget.joinTalentPool')}}
      <img src="@/assets/tool-tip.png" class="ml-2" v-tooltip="{content:this.$t('widget.thisJobsCompany'), placement:'bottom', offset: '10px'}" />
    </button>
  </div>
  <div v-if="activeItem === 'explore_companies'">
    <button @click="redirectToSignup"
            class="button is-primary is-fullwidth no-text-transform">{{this.$t('widget.createCompany')}}
      <img src="@/assets/tool-tip.png" class="ml-2" v-tooltip="{content:this.$t('widget.thisJobsTalent'), placement:'bottom', offset: '10px'}" />
    </button>
  </div>
  <div class="is-grouped" v-if="type === 'application'">
    <p class="control is-expanded has-icons-left">
      <input v-model="formSearchApplication" class="input" type="text" placeholder="Keyword">
      <span class="icon is-small is-left">
                <i class="fas fa-search"></i>
              </span>
    </p>
  </div>
  <div class="field is-grouped" v-if="showSearch">
    <div class="control">
      <input type="text"
      class="input"
      placeholder="Keyword"
      v-model="keywordValue"
      @keydown.prevent.enter="$emit('enter')" />
    </div>
    <div class="control" v-if="selectItems && selectItems.length > 0">
      <div class="select">
        <select v-model="selectedItemComp">
          <option v-for="item in selectItems" :key="item">
            {{ item }}
          </option>
        </select>
      </div>
    </div>
  </div>
</nav>
</template>

<script>
import {mapMutations, mapState} from 'vuex'
import Column from './column.vue'

export default {
  components: {Column},

  props: {
    active: {
      type: String,
      default: 'all'
    },
    tabItems: {
      type: Array,
      default: () => []
    },
    selectItems: {
      type: Array,
      default: () => []
    },
    selectedItem: {
      type: String
    },
    keyword: {
      type: String,
      default: ''
    },
    suffixes: {
      type: Array,
      default: null
    },
    showSearch: {
      type: Boolean,
      default: true
    },
    page: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    }
  },
  filters: {
    capitalize (value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  },
  computed: {
    ...mapState('widget', [
      'jobs',
      'companies',
      'talents',
      'totalJobs',
      'totalCompanies',
      'totalTalent'
    ]),
    ...mapState('widgetStyles', ['activeNav']),
    ...mapState('adminApplications', ['searchApplication']),
    formSearchApplication: {
      get () { return this.searchApplication },
      set (value) { this.setSearchApplication(value) }
    },
    isActive () {
      return this.activeNav
    },
    getWidth () {
      if (this.windowWidth <= 550) {
        return 'xs'
      }
      return 'lg'
    },
    keywordValue: {
      get () { return this.keyword },
      set (value) {
        this.$emit('update:keyword', value)
      }
    },
    selectedItemComp: {
      get () { return this.selectedItemModel || this.selectedItem },
      set (value) {
        this.$emit('select', value)
        this.selectedItemModel = value
      }
    },
    activeItem: {
      get () { return this.activeModel || this.active },
      set (value) {
        this.$emit('active', value)
        this.$emit('update:active', value)
        this.activeModel = value
      }
    },
    navBar: {
      get () { return this.navBarValue },
      set (value) { this.navBarValue = value; this.onNavItemClick(value) }
    }
  },
  data () {
    return {
      filter: null,
      selectedItemModel: null,
      activeModel: null,
      windowWidth: 0,
      navBarValue: ''
    }
  },
  watch: {
    activeItem (newValue) {
      this.navBarValue = newValue
    }
  },
  mounted () {
    this.windowWidth = window.innerWidth
    window.addEventListener('resize', () => {
      this.windowWidth = window.innerWidth
    })
    this.navBarValue = this.activeItem
  },
  methods: {
    ...mapMutations('adminApplications', ['setSearchApplication']),
    redirectHandler () {
      window.open(`${window.location.origin}/login`, '_blank')
    },
    redirectToSignup () {
      window.open(`${window.location.origin}/signup`, '_blank')
    },
    onNavItemClick (item) {
      this.activeItem = item
    },
    suffix (index) {
      if (!this.suffixes || this.suffixes.length <= index) { return '' }
      return `: ${this.suffixes[index]}`
    },
    getCategory (value) {
      if (value === 'all') {
        return this.$t('jobs.cateAll')
      } else if (value === 'applied') {
        return this.$t('jobs.cateApplied')
      } else if (value === 'hired') {
        return this.$t('jobs.cateHired')
      } else if (value === 'search_jobs') {
        return `${this.$t('widget.searchJobs')} (${this.totalJobs})`
      } else if (value === 'explore_companies') {
        return `${this.$t('widget.exploreCompanies')} (${this.totalCompanies})`
      } else if (value === 'Browse Talent') {
        return `${this.$t('widget.browseTalent')} (${this.totalTalent})`
      } else if (value === 'active') {
        return this.$t('jobs.active')
      } else if (value === 'closed') {
        return this.$t('jobs.closed')
      }
      return value
    }
  }
}
</script>

<style lang="scss" scoped>
.list-nav {
  height: 72px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-top: 24px;
  margin-bottom: 40px;

  > .field .control {
    margin-top: 0;
  }
}

@media (max-width: 550px) {
  .list-nav{
    margin-top: 0px;
    margin-bottom: 20px;
  }
}

.ml-2{
  margin-left: 6px;
}

.no-text-transform{
  text-transform: none;
}

.width-100{
  width: 100%;
}
.mt-24{
  margin-top: 24px;
}

.bold{
  font-weight: bold !important;
}
.p-0{
  padding: 0px !important;
}

.mb-8{
  margin-bottom: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/general/list-nav.vue